function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "size", "title", "tabList", "divided", "prefixCls", "bodyStyle", "styles", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { isNullValue } from '@oceanbase/util';
import { Card as AntCard, Space, Tag } from 'antd';
import classNames from 'classnames';
import React, { useContext } from 'react';
import ConfigProvider from "../config-provider";
import { isHorizontalPaddingZero } from "../_util";
import useStyle, { genTableStyle } from "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from 'antd/es/card/Card';
export * from 'antd/es/card';
var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref2, _styles$body;
  var children = _ref.children,
    size = _ref.size,
    title = _ref.title,
    tabList = _ref.tabList,
    outerDivided = _ref.divided,
    customizePrefixCls = _ref.prefixCls,
    bodyStyle = _ref.bodyStyle,
    styles = _ref.styles,
    className = _ref.className,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(ConfigProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    contextCard = _useContext.card;
  var divided = (_ref2 = outerDivided !== null && outerDivided !== void 0 ? outerDivided : contextCard === null || contextCard === void 0 ? void 0 : contextCard.divided) !== null && _ref2 !== void 0 ? _ref2 : true;
  var prefixCls = getPrefixCls('card', customizePrefixCls);
  var tabsPrefixCls = getPrefixCls('tabs', customizePrefixCls);
  var _useStyle = useStyle(prefixCls, tabsPrefixCls),
    wrapSSR = _useStyle.wrapSSR;

  // card body no horizontal padding
  var noBodyHorizontalPadding = isHorizontalPaddingZero(bodyStyle === null || bodyStyle === void 0 ? void 0 : bodyStyle.padding) || isHorizontalPaddingZero(styles === null || styles === void 0 || (_styles$body = styles.body) === null || _styles$body === void 0 ? void 0 : _styles$body.padding);
  var cardCls = classNames(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-has-title"), !!title), "".concat(prefixCls, "-no-divider"), !divided), "".concat(prefixCls, "-no-body-horizontal-padding"), noBodyHorizontalPadding), className);
  var newTabList = tabList === null || tabList === void 0 ? void 0 : tabList.map(function (item) {
    if (!isNullValue(item.tag)) {
      return _objectSpread(_objectSpread({}, item), {}, {
        tab: /*#__PURE__*/_jsxs(Space, {
          size: 4,
          children: [item.tab, /*#__PURE__*/_jsx(Tag, {
            bordered: false,
            className: "".concat(tabsPrefixCls, "-tab-tag"),
            children: item.tag
          })]
        })
      });
    }
    return item;
  });
  return wrapSSR( /*#__PURE__*/_jsx(AntCard, _objectSpread(_objectSpread({
    ref: ref,
    size: size,
    title: title,
    tabList: newTabList,
    prefixCls: customizePrefixCls,
    bodyStyle: bodyStyle,
    styles: styles,
    className: cardCls
  }, restProps), {}, {
    children: children
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = AntCard.displayName;
}
export default Object.assign(Card, {
  Grid: AntCard.Grid,
  Meta: AntCard.Meta,
  genTableStyle: genTableStyle
});